"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultModule = exports.EditorialErrorMessage = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _jsxRuntime = require("react/jsx-runtime");
const defaultModule = exports.defaultModule = 'Unknown';
const EditorialErrorMessage = (param)=>{
    let { errorMessage, modulePosition, module, title } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_presentationComponents.ErrorMessage, {
        title: title,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                children: "Module:"
            }),
            " ",
            module !== null && module !== void 0 ? module : defaultModule,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                children: "Position:"
            }),
            " ",
            modulePosition + 1,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                children: "Reason:"
            }),
            " ",
            errorMessage
        ]
    });
};
exports.EditorialErrorMessage = EditorialErrorMessage;
